import React, { useCallback } from 'react';
import type { AdditionalEventAttributes } from '@atlassian/jira-common-experience-tracking-analytics';
import OpTrigger from '@atlassian/jira-common-util-op-triggers/src/on-mount';
import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import responseToSla from '@atlassian/jira-software-sla-tracker/src/services/response-to-sla/index.tsx';
import { SwagError } from '@atlassian/jira-software-swag/src/common/utils/error/index.tsx';
import { SLA_FAILURE_REASON_CRITICAL_DATA_FAILED } from '../../model/constants';

type Props = {
	error: Error | null;
	onExperienceFailure: (extraLocation?: string, attributes?: AdditionalEventAttributes) => void;
};

const VelocityErrorToSLA = ({ error, onExperienceFailure }: Props) => {
	const onUnknownError = useCallback(
		() =>
			onExperienceFailure('', {
				failureReason: SLA_FAILURE_REASON_CRITICAL_DATA_FAILED,
			}),
		[onExperienceFailure],
	);

	if (error instanceof FetchError) {
		return responseToSla(
			new SwagError({ networkError: error, errorMessage: error.message }),
			'velocityChart',
		);
	}

	return <OpTrigger op={onUnknownError} />;
};

export default VelocityErrorToSLA;
